// extracted by mini-css-extract-plugin
module.exports = {"crudTable":"CrudTable_crudTable__2vDnh","buttons":"CrudTable_buttons__3SFoy","remove":"CrudTable_remove__16GNy"};